// extracted by mini-css-extract-plugin
module.exports = {"title":"title_title__1NJAt","titleSpan":"title_titleSpan__2Z1FM","titleSpan2":"title_titleSpan2__3Z_F3"};